import React, { createContext, useContext, useState } from 'react';

const errorMessages = {
  validateEmailFailed: {
    email: '',
    confirmEmail: 'errors.invalid_email_validate_api',
  },
  alreadyInUse: {
    email: '',
    confirmEmail: 'errors.invalid_email_already_in_use',
  },
};

interface ContextProps {
  emailInput: {
    forceError: boolean;
    resetError: () => void;
    errorMessage: string;
  };
  confirmEmailInput: {
    forceError: boolean;
    resetError: () => void;
    errorMessage: string;
    resetInputValue: () => void;
    setResetCallback: (callback: () => void) => void;
  };
  events: {
    validateEmailFailed: () => void;
    validateAlreadyInUse: () => void;
  };
}

const EmailSharedValidationContext = createContext<ContextProps>({} as ContextProps);

export const useEmailSharedValidation = () => useContext(EmailSharedValidationContext);

export const EmailSharedValidationProvider: React.FC = ({ children }) => {
  const [emailForceError, setEmailForceError] = useState<boolean>(false);
  const [confirmEmailForceError, setConfirmEmailForceError] = useState<boolean>(false);

  const [emailErrorMessage, setEmailErrorMessage] = useState<string>('');
  const [confirmEmailErrorMessage, setConfirmEmailErrorMessage] = useState<string>('');

  const [resetCallback, setResetCallback] = useState<() => void>(() => () => null);

  const resetEmailError = () => {
    setEmailForceError(false);
  };

  const resetConfirmEmailError = () => {
    setConfirmEmailForceError(false);
  };

  const validateEmailFailed = () => {
    setEmailForceError(false);
    setConfirmEmailForceError(true);

    const currentError = errorMessages.validateEmailFailed;

    setEmailErrorMessage(currentError.email);
    setConfirmEmailErrorMessage(currentError.confirmEmail);
  };

  const validateAlreadyInUse = () => {
    setEmailForceError(true);
    setConfirmEmailForceError(true);

    const currentError = errorMessages.alreadyInUse;

    setEmailErrorMessage(currentError.email);
    setConfirmEmailErrorMessage(currentError.confirmEmail);
  };

  const resetInputValue = () => {
    resetCallback();
  };

  const contextValue: ContextProps = {
    emailInput: {
      forceError: emailForceError,
      resetError: resetEmailError,
      errorMessage: emailErrorMessage,
    },
    confirmEmailInput: {
      forceError: confirmEmailForceError,
      resetError: resetConfirmEmailError,
      errorMessage: confirmEmailErrorMessage,
      setResetCallback,
      resetInputValue,
    },
    events: {
      validateEmailFailed,
      validateAlreadyInUse,
    },
  };

  return <EmailSharedValidationContext.Provider value={contextValue}>{children}</EmailSharedValidationContext.Provider>;
};
